export default function HeroSection() {
  return (
    <section className="relative bg-white pt-32 pb-16 px-8 md:px-12 lg:px-[8%]">
      <div className="max-w-[900px] mx-auto text-center">
        <h1 className="text-[clamp(2.2rem,4.5vw,3.4rem)] font-bold text-[#222222] leading-tight tracking-[-0.02em] mb-5">
          Todos los productos
        </h1>
        <p className="text-[17px] text-[#6B6860] leading-relaxed max-w-[650px] mx-auto">
          Mis recomendaciones honestas de belleza, wellness y hogar. Solo lo que realmente funciona.
        </p>
      </div>
    </section>
  );
}
